export const countyFeatureKey = 'counties';
export type CountyModel = {
  id: string;
  name: string;
  countryId: string;
};
